import React from 'react';
import { FormattedMessage } from 'react-intl';
import './multi-select-with-role.scss';

const MultiSelectWithRoleHeader = ({ searchInput }) => {
    return (
        <div className='multi-select-with-role_header flex w-100'>
            <div className='multi-select-with-role_name'>
                <FormattedMessage
                    description='Label text'
                    defaultMessage='Name'
                    id='oe.common.name'
                />
            </div>
            <div className='multi-select-with-role_role'>
                <FormattedMessage
                    description='Label text'
                    defaultMessage='Role'
                    id='oe.common.role'
                />
            </div>
            <div className='multi-select-with-role_search'>{searchInput}</div>
        </div>
    );
};

export default MultiSelectWithRoleHeader;
